export default "c7f9e8bb9edc2f3f.jpg"